import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Clock, Calendar } from 'lucide-react';
import Breadcrumb from '../components/Breadcrumb';
import { blogPosts } from '../mock';

const Blog = () => {
  return (
    <div className="bg-white py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: 'Ratgeber' }]} />
        
        <h1 className="text-4xl font-bold text-[#0F172A] mb-6">Ratgeber Haushaltsauflösung</h1>
        <p className="text-lg text-gray-700 mb-12 max-w-3xl">
          Hilfreiche Artikel rund um Haushalts- und Wohnungsauflösungen in Dortmund. 
          Von Checklisten über Preisfaktoren bis zu rechtlichen Hinweisen.
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Link key={post.id} to={`/blog/${post.slug}`}>
              <Card className="h-full border-2 border-gray-100 hover:border-[#16A34A] hover:shadow-lg transition-all">
                <CardContent className="pt-6">
                  <div className="flex items-center gap-4 text-sm text-gray-600 mb-4">
                    <div className="flex items-center gap-1">
                      <Calendar className="h-4 w-4" />
                      <span>{new Date(post.date).toLocaleDateString('de-DE')}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Clock className="h-4 w-4" />
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                  <h2 className="text-2xl font-semibold text-[#0F172A] mb-4">{post.title}</h2>
                  <p className="text-gray-700 mb-4">{post.excerpt}</p>
                  <span className="text-[#16A34A] font-medium hover:underline">Weiterlesen →</span>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;